import { CheckboxFilter } from '~/app/features/Gallery/components/Filters/Checkbox'
import { RadioFilter } from '~/app/features/Gallery/components/Filters/Radio'
import { ColorFilter } from '~/app/features/Gallery/components/Filters/Color'
import { FlatTaxonomy } from '~/app/features/Gallery/components/Filters/FlatTaxonomy'
import { FacetedTaxonomy } from '~/app/features/Gallery/components/Filters/FacetedTaxonomy'
import { ProductColor } from '~/app/features/Gallery/components/Filters/ProductColor'
import { FILTER_TYPE } from 'shared/constants'
import { normalizeFilterType } from '~/app/features/Gallery/components/Filters/util'

interface PropTypes {
  filter: State.Filter
}

export const Filter = (props: PropTypes) => {
  const {
    filter: { type },
  } = props

  switch (normalizeFilterType(type)) {
    case FILTER_TYPE.CHECKBOX:
      return <CheckboxFilter {...props} />
    case FILTER_TYPE.RADIO:
      return <RadioFilter {...props} />
    case FILTER_TYPE.COLOR:
      return <ColorFilter {...props} />
    case FILTER_TYPE.FLAT_TAXONOMY:
      return <FlatTaxonomy {...props} />
    case FILTER_TYPE.FACETED_TAXONOMY:
      return <FacetedTaxonomy {...props} />
    case FILTER_TYPE.SUBSTRATE_COLOR:
      return <ProductColor {...props} />
    default:
      return null
  }
}

Filter.displayName = 'Filter'
